export const courseFlow = {
  title: 'Course Flow',
  subtitle: 'Discover the EachTeach learning process',
  
  // Hero
  heroTitle: 'Course Flow',
  heroSubtitle: 'From foundational A-C level courses to practice-focused Additional Lessons',
  
  // Level Check Notice
  levelCheckTitle: 'About Level Check Test',
  levelCheckDescription1: 'All students are required to take a Level Check Test.',
  levelCheckDescription2: 'Based on your test results, we\'ll determine your current language level (A, B1, B2, C) and help you start at the optimal level.',
  levelCheckDescription3: 'Beginners can start from Level A, while those with existing foundation can begin from B1 or B2,',
  levelCheckDescription4: 'allowing you to learn efficiently without wasting time.',
  levelCheckButton: 'Take Level Check Test',
  registerButton: 'Register First',
  
  // Foundation Courses
  foundationTitle: 'Foundation Courses (A-C)',
  
  // Level A
  levelATitle: 'Complete Beginner',
  levelALessons: '18 Lessons + A Level Word Note',
  levelADescription: 'For complete beginners. Learn basic vocabulary and grammar foundations.',
  
  // Extra Lessons
  extraLessonAB1: 'Extra Lesson (A→B1)',
  extraLessonAB1Description: '1 Test + 2 Reinforcement Lessons = Price of 3 lessons',
  
  // Level B1
  levelB1Title: 'Intermediate Foundation',
  levelB1Lessons: '14 Lessons',
  levelB1Description: 'Build fluency in daily conversation and expand vocabulary.',
  
  extraLessonB1B2: 'Extra Lesson (B1→B2)',
  extraLessonB1B2Description: '1 Test + 2 Reinforcement Lessons = Price of 3 lessons',
  
  // Level B2
  levelB2Title: 'Professional Level',
  levelB2Lessons: '10 Lessons',
  levelB2Description: 'Level capable of customer service work. Refine nuances and idioms.',
  
  extraLessonB2C: 'Extra Lesson (B2→C)',
  extraLessonB2CDescription: '1 Test + 2 Reinforcement Lessons = Price of 3 lessons',
  
  // Level C
  levelCTitle: 'Near-Native Fluency',
  levelCLessons: '10 Lessons',
  levelCDescription: 'Near-native fluency. Master cultural nuances and advanced expressions.',
  
  // Additional Lessons
  additionalTitle: 'Additional Lessons',
  additionalBadge: 'After Completing A-C Levels',
  additionalSubtitle: '8 specialized field-specific courses.',
  additionalPricing: 'Pricing is 1.2x regular lessons.',
  
  // Courses
  course1Title: 'Daily Life & Casual Communication',
  course1Description: 'Daily conversation, small talk, slang, idioms, etc.',
  
  course2Title: 'Customer Service & Hospitality Communication',
  course2Description: 'Taking orders, explanations, recommendations, complaint handling, etc.',
  
  course3Title: 'Kitchen & Culinary Communication',
  course3Description: 'Instructions, ingredient/cooking terms, safety checks, etc.',
  
  course4Title: 'Sales & Cashier Communication',
  course4Description: 'Product descriptions, inventory checks, payments, returns/exchanges, etc.',
  
  course5Title: 'Hotel & Front Desk Operations',
  course5Description: 'Check-in/out, facility guidance, phone handling, etc.',
  
  course6Title: 'Cleaning & Back Office Operations',
  course6Description: 'Understanding instructions, confirmation expressions, checklists, safety-related, etc.',
  
  course7Title: 'Resort & Seasonal Work',
  course7Description: 'Communication in multinational environments at tourist destinations and short-term employment',
  
  course8Title: 'Workplace & Advanced Communication',
  course8Description: 'Email, reporting, coordination, requests, trouble sharing, etc.',
  
  lessonsLabel: 'Lessons',
  registerNow: 'Register Now'
};
